"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogResource = void 0;
exports.LogResource = {
    Org: "org",
    Assistant: "assistant",
    Analytics: "analytics",
    Credential: "credential",
    PhoneNumber: "phone-number",
    Block: "block",
    VoiceLibrary: "voice-library",
    Provider: "provider",
    Tool: "tool",
    Token: "token",
    Template: "template",
    Squad: "squad",
    Call: "call",
    File: "file",
    Metric: "metric",
    Log: "log",
};
